define('editor/metadata/metadata',['durandal/app', 'plugins/http', 'knockout'], function (app, http, ko) {
    var viewmodel = function () {
        var self = this;

        self.editorMapId = 0;
        self.title = ko.observable('');
        self.description = ko.observable('');
        self.size = ko.observable('');
        self.height = ko.observable();
        self.width = ko.observable();
        self.teamId = ko.observable(0);
        self.selectedTeam = ko.observable();
        self.useLabelsLayer = ko.observable(true);
        self.canToggleLabelsLayer = ko.observable(true);

        self.doneCallback = null;
        self.failCallback = null;

        self.loadEditorMap = function () {
            var url = "/api/editor/edit/" + self.editorMapId;

            return http.get(url)
                .then(self.setData);
        };

        self.setData = function (response) {
            if (response.data) {
                self.title(response.data.editorMap.title);
                self.description(response.data.editorMap.description);
                self.size(response.data.editorMap.size);
                self.height(response.data.editorMap.height);
                self.width(response.data.editorMap.width);
                self.teamId(response.data.editorMap.teamId);
                self.useLabelsLayer(response.data.editorMap.useLabelsLayer);
                self.setSelectedTeam();
                self.canToggleLabelsLayer(!!response.data.editorMap.labelsLayer);
            }
        };

        self.saveEditorMap = function () {
            var url = "/api/editor/metadata";
            var data = {
                id: self.editorMapId,
                title: self.title(),
                description: self.description(),
                size: self.size(),
                useLabelsLayer: self.useLabelsLayer()
            };
            if (self.teams().length > 1) {
                data.teamId = self.selectedTeam().key;
            } else {
                data.teamId = self.teams()[0].key;
            }

            http.post(url, data)
                .then(function(response) {
                    if (response.success) {
                        self.editorMapId = response.data.editorMapId;
                        return self.loadEditorMap();
                    } else {
                        return response.error;
                    }
                })
                .then(function(error) {
                    if (error) {
                        self.failCallback(error);
                    } else {
                        self.doneCallback({
                            id: self.editorMapId,
                            title: self.title(),
                            height: self.height(),
                            width: self.width(),
                            useLabelsLayer: self.useLabelsLayer()
                        });
                    }
                }).fail(self.failCallback);
        };

        self.activate = function (doneCallback, failCallback, editorMapId) {
            self.doneCallback = doneCallback;
            self.failCallback = failCallback;
            self.editorMapId = editorMapId;
            self.teams = ko.observableArray([]);
            var url = '/api/auth/current/teams';
            http.get(url).then(function(response) {
                if (response.success) {
                    self.teams(response.data.teams);
                    self.setSelectedTeam();
                }
            });
        };

        self.setSelectedTeam = function() {
            if (self.teamId() > 0 && self.teams().length > 0) {
                var team = ko.utils.arrayFirst(self.teams(), function (t) {
                    return t.key === self.teamId();
                });
                self.selectedTeam(team);
            }
        };

        self.compositionComplete = function () {
            if (self.editorMapId) {
                return self.loadEditorMap();
            }
        };
    };

    return viewmodel;
});
